export default "__VITE_ASSET__DalOKo5E__"